

import React , {useState,useRef,createContext} from 'react';
import {Routes , Route,useLocation} from 'react-router-dom'


import  './App.css'


import Header from "./components/pages/Header";
import Footer from "./components/pages/Footer";
import Home from "./components/pages/Home";
import Category from "./components/pages/Category";
import Story from "./components/pages/story.jsx";
export const globalContext = createContext()
import PageNotFound from './components/pages/pageNotFound.jsx';


import ScrollUp from './components/common/scrollUp'
import ScrollRestoration from './components/common/onWindowLoadUp'
import RouteTracker from './components/common/routeTracker'



 
const App = ({data}) =>{
            
        let isMobile = data?.[1].isMobile || false
      

      
       

          const [cats,setCats] = useState([])
            const location = useLocation();
    
            const segments = location.pathname.split("/").filter(Boolean);
            const isStoryPage = segments.length === 2;

             const appShellContainerRef = useRef(null);
              const [mobile,setMobile] = useState(isMobile)

  return (
    <div className={`app-shell ${isStoryPage ? "chrome-hidden" : ""}`}>
    <globalContext.Provider value={{cats,setCats,mobile,setMobile}}  >
      {!isStoryPage && <Header />}
      <main className={isStoryPage ? "app-main story-mode" : "app-main"}>
        <Routes>
          <Route path="/" element={<Home data={data} />} />
          <Route path="/:category" element={<Category data={data} />} />
          <Route path="/:category/:slug" element={<Story data={data} />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </main>
       <ScrollUp containerSelector={'.app-shell'} />
      <ScrollRestoration containerRef={appShellContainerRef} />
      <RouteTracker />
      {!isStoryPage && <Footer />}
  </globalContext.Provider>
    </div>
  );
}


export default App;
